var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9C7.84518 9 8.125 8.72018 8.125 8.375C8.125 8.02982 7.84518 7.75 7.5 7.75C7.15482 7.75 6.875 8.02982 6.875 8.375C6.875 8.72018 7.15482 9 7.5 9Z",
    stroke: "#0B3B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75C7.84518 3.75 8.125 3.47018 8.125 3.125C8.125 2.77982 7.84518 2.5 7.5 2.5C7.15482 2.5 6.875 2.77982 6.875 3.125C6.875 3.47018 7.15482 3.75 7.5 3.75Z",
    stroke: "#0B3B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.25C7.84518 14.25 8.125 13.9702 8.125 13.625C8.125 13.2798 7.84518 13 7.5 13C7.15482 13 6.875 13.2798 6.875 13.625C6.875 13.9702 7.15482 14.25 7.5 14.25Z",
    stroke: "#0B3B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMore);
export default __webpack_public_path__ + "static/media/Add-more.17cd82e840b988bfb13e9de304a92fd3.svg";
export { ForwardRef as ReactComponent };